import { render, staticRenderFns } from "./addCar.vue?vue&type=template&id=47594204&scoped=true&lang=html"
import script from "./addCar.vue?vue&type=script&lang=js"
export * from "./addCar.vue?vue&type=script&lang=js"
import style0 from "./addCar.vue?vue&type=style&index=0&id=47594204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47594204",
  null
  
)

export default component.exports